import React from 'react';

import isFunction from 'lodash/isFunction';

import useTreeItem from './useTreeItem';

const TreeItem = ({
  children,
  to,
  node,
  element,
  lastItem,
  path,
  currentParentItem,
}) => {
  const { currentItem, openItem, onClickLink } = useTreeItem(to);

  const elementProps = {
    to,
    node,
    path,
    current: currentItem,
    currentParent: currentParentItem,
    open: openItem,
    last: lastItem,
    onClickLink,
  };

  return (
    <React.Fragment>
      {isFunction(element)
        ? element(elementProps)
        : React.isValidElement(element) &&
          React.cloneElement(React.Children.only(element), elementProps)}
      {openItem
        ? currentItem
          ? React.Children.map(children, child =>
              React.isValidElement(child)
                ? React.cloneElement(child, {
                    currentParentItem: true,
                  })
                : child
            )
          : children
        : null}
    </React.Fragment>
  );
};

export default TreeItem;
